import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  effect,
  Inject,
  inject,
  Input,
  PLATFORM_ID,
  signal,
  Signal,
} from '@angular/core';
import { DaysAgoPipe } from '../../../pipes/days-ago.pipe';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '../../buttons/button/button.component';
import { Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TravellerStoryReadMoreComponent } from '../traveller-story-read-more/traveller-story-read-more.component';
import { Store } from '@ngrx/store';
// export interface ITravellerStory {
//   travelerName?: string;
//   photos?: string;
//   travelDate?: string;
//   rating: number;
// }
export interface ITravellerStory {
  _id: string;
  travelerName: string;
  travelDate: string;
  storyTitle: string;
  destination: string;
  storyDescription: string;
  rating: number;
  photos: string[];
  cityInfo?: any;
  destinationInfo?: {
    _id: string;
    name: string;
    id: string;
  };
  packagesInfo?: any;
  id: string;
}

@Component({
  selector: 'app-traveller-story-card',
  standalone: true,
  imports: [
    CommonModule,
    DaysAgoPipe,
    MatIconModule,
    ButtonComponent,
    ButtonComponent,
    RouterModule
  ],
  templateUrl: './traveller-story-card.component.html',
  styleUrl: './traveller-story-card.component.scss',
})
export class TravellerStoryCardComponent {
  @Input() data: any = {};
  @Input() showReadMore: boolean = false;
  @Input() travellerStoriesData: ITravellerStory = {} as ITravellerStory;
  private route = inject(Router);
  private dialog = inject(MatDialog);
  private store = inject(Store);
  travellerStoriesState: Signal<{ travellerStories: any[] }> = signal({
    travellerStories: [],
  });


  constructor(@Inject(PLATFORM_ID) private platformId: Object,
  ) {
    // this.travellerStoriesState = toSignal(
    //   this.store.select(selectTravellerStories).pipe(
    //     startWith({ travellerStories: [], isLoading: false, error: null }),
    //     map((state: any) =>
    //       state
    //         ? { travellerStories: state.travellerStories?.data }
    //         : { travellerStories: [] }
    //     )
    //   ),
    //   { initialValue: { travellerStories: [] } }
    // );
    // effect(() => {
    //   const data = this.travellerStoriesState();
    // });
  }

  get truncatedDestinationName(): string {
    if (!isPlatformBrowser(this.platformId)) return '';

    const maxLength = window.innerWidth <= 767 ? 30 : 12;
    return this.truncate(this.data?.destinationInfo?.name, maxLength);
  }

  truncate(text: string = '', maxLength: number): string {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  }

  // getStarsArray(star: number) {
  //   return Array.from({ length: star }, (_, index) => index);
  // }

  getStarsArray(rating: number): { filled: boolean }[] {
    return Array.from({ length: 5 }, (_, index) => ({
      filled: index < rating,
    }));
  }

  navigateToViewPackage(destinationId: string) {
    this.route.navigate(['package'], {
      queryParams: { destination: destinationId },
    });
  }

  openLeadModal(travellerStory: ITravellerStory) {
    this.dialog.open(TravellerStoryReadMoreComponent, {
      data: travellerStory, // Passing the specific story data to the modal
      height: 'auto',
      width: 'auto',
      hasBackdrop: true,
      backdropClass: 'custom-backdrop',
      panelClass: 'lead-form-panel',
      disableClose: true,
    });
  }
}
